import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const EVENT_ID_PARAM = 'eventId';

export const useEventIdParam = () => {
  const history = useHistory();
  const { pathname, search } = useLocation();

  const eventId = new URLSearchParams(search).get(EVENT_ID_PARAM);

  const openEvent = useCallback(
    (id: string) => {
      const params = new URLSearchParams(search);
      params.set(EVENT_ID_PARAM, id);
      history.push({ pathname, search: params.toString() });
    },
    [history, pathname, search]
  );

  const closeEvent = useCallback(() => {
    const params = new URLSearchParams(search);
    params.delete(EVENT_ID_PARAM);
    history.replace({ pathname, search: params.toString() });
  }, [history, pathname, search]);

  return { eventId, openEvent, closeEvent };
};
